/* eslint-disable */
/**
 * Custom Plaid GraphQL queries
 * These are manually maintained to avoid over-fetching and to prevent
 * being overwritten by Amplify codegen.
 *
 * NOTE: Do NOT use auto-generated queries from src/graphql/queries.ts for Plaid.
 * Those expose plaidAccessToken which is a security risk.
 * Sent to the CDK AppSync API by app/services/plaid.service.ts and served by the
 * v2Shared Lambda (SEE-1652 / SEE-1228), which replaced the plaidApiResolver Lambda.
 */

/**
 * Get PlaidLinkedBankAccounts by paidolId using the secure backend resolver.
 * Returns only safe data - access_token is NEVER exposed.
 */
export const getPlaidLinkedBankAccountsByPaidolId = /* GraphQL */ `
  query GetPlaidLinkedBankAccountsByPaidolId($paidolId: ID!, $status: String) {
    getPlaidLinkedBankAccountsByPaidolId(paidolId: $paidolId, status: $status) {
      items {
        id
        paidolId
        plaidAccountId
        plaidItemId
        highnoteAccountId
        accountName
        accountMask
        accountType
        verificationMethod
        status
        linkedAt
        verifiedAt
        closedAt
        failureReason
      }
    }
  }
`;
